import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const CrmSettings = lazy(() => import("@/pages/CrmSettings/CrmSettings"));
const CrmConfiguration = lazy(
  () => import("@/pages/CrmConfiguration/CrmConfiguration"),
);

const CrmRoute: RouteConfig = {
  path: "",
  pageName: "CRM",
  permission: ["CRMSettings"],
  children: {
    CRM_Setting: {
      path: "crmsetting",
      element: <CrmSettings />,
      pageName: "CRM Setting",
      sidebar: { show: true },
    },
    CRM_Configuration: {
      path: "NewCustomerConfig",
      element: <CrmConfiguration />,
      pageName: "CRM Configuration",
      sidebar: { show: true },
    },
  },
};

export default CrmRoute;
